export const sendGtmEvent = (options, elm) => {
    const gtm = window.dataLayer || [];

    const defaults = {
        component: 'Series Selector',
        componentIndex: null,
        elementId: '',
        elementNodeName: '',
        elementText: '',
        elementValue: '',
        event: 'series_selector',
        eventAction: '',
        eventName: 'click',
        timestamp: Date.now(),
        pagePath: window.location.href,
    };

    let evtData = Object.assign({}, defaults, options);

    if (elm) {
        const componentElm = elm.closest('[data-dm^="component."]');
        const componentIndex = componentElm?.getAttribute('data-dm-component-index');
        const elementId = elm.id;
        const elementText = evtData.elementText || elm.textContent?.trim();
        const elementNodeName = elm.tagName;

        const elmData = {
            componentIndex,
            elementId,
            elementText,
            elementValue: elementText,
            elementNodeName,
            elementDataset: elm.dataset || null,
        };

        evtData = Object.assign(evtData, elmData);
    }

    gtm.push(evtData);
};
